(() => {
	let $searchForm, $input, $inputHidden;

	// Init
	// ----------------------------------------

	function initSearch() {
		const $search = $('#search-form');

		$search.on('submit', function (e) {
			e.preventDefault();
			handleSearchSubmit(this);
		});
	}

	function initSearchPage() {
		$input = $('#keywords');
		$inputHidden = $('#keywords-hidden');
		$searchForm = $('#search-page-form');
		$searchFilter = $('#search-filter');

		calcWidth();

		$input.on('input', function () {
			calcWidth();
		});

		$searchForm.on('submit', function (e) {
			e.preventDefault();
			handleSearchSubmit(this);
		});

		$searchFilter.on('change', function () {
			const val = $searchFilter.val();

			navigateTo(val);
		});
	}

	// Func
	// ----------------------------------------

	function calcWidth() {
		$inputHidden.text($input.val());

		let width = $inputHidden.width();
		let containerWidth = $searchForm.width();

		if (width <= containerWidth) {
			$input.width(width);
		} else {
			$input.width(containerWidth);
		}
	}

	function handleSearchSubmit(form) {
		const data = new FormData(form);
		const action = form.getAttribute('action');

		navigateTo(`${action}?keywords=${encodeURIComponent(data.get('keywords'))}`);
	}

	// Events
	// ----------------------------------------

	$WINDOW.on('resize', function () {
		if ($BODY.hasClass('search-page')) {
			calcWidth();
		}
	});

	$WINDOW.on('load', function () {
		if ($BODY.hasClass('search-page')) {
			calcWidth();
		}
	});

	$WINDOW.on('page:content-updated', (e) => {
		initSearchPage();
	});

	$DOC.ready(() => {
		initSearch();
		initSearchPage();
	});
})();
